export default __webpack_public_path__ + "static/shutterstock_7-94efee804ef001bf4b18ca5d159e8db6.jpg";